import styleVariants from "./style-variants.module.scss";

export const textVariants = {
  light: {
    true: ['light-txt']
  },
  bold: {
    true: ['bold-txt']
  },
  uppercase: {
    true: ['uppercase-txt']
  },
  underline: {
    true: ['underline-txt']
  },
  lineHeight: {
    xsmall: ['lh-xsmall'],
    small: ['lh-small'],
    medium: ['lh-medium'],
    big: ['lh-big']
  },
  center: {
    true: ['txt-center']
  },
  right: {
    true: ['txt-right']
  },
  left: {
    true: ['txt-left']
  },
  align: {
    left: ['txt-left'],
    right: ['txt-right'],
    center: ['txt-center']
  }
}

export const marginVariants = {
  margin: {
    verticalXSmall: ['mb-xs', 'mt-xs'],
    verticalSmall: ['mb-s', 'mt-s'],
    verticalMedium: ['mb-m', 'mt-m'],
    verticalLarge: ['mb-l', 'mt-l'],
    verticalNone:['mt-0','mb-0'],
    bottomXSmall: ['mb-xs'],
    bottomSmall: ['mb-s'],
    bottomMedium: ['mb-m'],
    bottomLarge: ['mb-l'],
    topXSmall: ['mt-xs'],
    topSmall: ['mt-s'],
    topMedium: ['mt-m'],
    topLarge: ['mt-l'],
    none:['no-margin'],
  }
}

export const paddingVariants = {
  padding: {
    verticalXSmall: ['pb-xs', 'pt-xs'],
    verticalSmall: ['pb-s', 'pt-s'],
    verticalMedium: ['pb-m', 'pt-m'],
    verticalLarge: ['pb-l', 'pt-l'],
    verticalNone: ['pb-0', 'pt-0'],
    bottomXSmall: ['pb-xs'],
    bottomSmall: ['pb-s'],
    bottomMedium: ['pb-m'],
    bottomLarge: ['pb-l'],
    topXSmall: ['pt-xs'],
    topSmall: ['pt-s'],
    topMedium: ['pt-m'],
    topLarge: ['pt-l'],
    none:['no-padding'],
  }
}

export const sharedFlexVariants = {
  flexAlignment: {
    rowCenterCenter: styleVariants.flexRowCenterCenter,
    rowCenterTop: styleVariants.flexRowCenterTop,
    rowCenterBottom: styleVariants.flexRowCenterBottom,
    rowSpaceBetweenCenter: styleVariants.flexRowSpaceBetweenCenter,
    rowLeftCenter: styleVariants.flexRowLeftCenter,
    rowLeftTop: styleVariants.flexRowLeftTop,
    rowLeftBottom: styleVariants.flexRowLeftBottom,
    rowRightCenter: styleVariants.flexRowRightCenter,
    rowRightTop: styleVariants.flexRowRightTop,
    rowRightBottom: styleVariants.flexRowRightBottom,
    columnCenterCenter: styleVariants.flexColCenterCenter,
    columnCenterTop: styleVariants.flexColCenterTop,
    columnCenterBottom: styleVariants.flexColCenterBottom,
    columnCenterSpaceBetween: styleVariants.flexColCenterSpaceBetween,
    columnLeftCenter: styleVariants.flexColLeftCenter,
    columnLeftTop: styleVariants.flexColLeftTop,
    columnLeftBottom: styleVariants.flexColLeftBottom,
    columnRightCenter: styleVariants.flexColRightCenter,
    columnRightTop: styleVariants.flexColRightTop,
    columnRightBottom: styleVariants.flexColRightBottom,
  },
  flexReverse: {
    true: styleVariants.reverseOrder
  },
  flexWrap: {
    no: styleVariants.flexWrapNo,
    wrap: styleVariants.flexWrap
  },
  // flexGrow: {
  //   true: styleVariants.flexGrow
  // },
  flexSize: {
    maxSpace: styleVariants.flexSizeMaxSpace,
    expand: styleVariants.flexSizeExpand,
    content: styleVariants.flexSizeContent
  },
  flexFixedGap: {
    s: "flex-gap-s",
    m: "flex-gap-m",
    l: "flex-gap-l",
  }
}
